(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["adv-om-os"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('adv-om-os')) {
    customElements.define('adv-om-os', class extends HTMLElement {
      connectedCallback() {
        var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var animate = this.dataset.animate === 'true' && !reduce && ('IntersectionObserver' in window);
        var host = this;

        var countUp = function (el) {
          var raw = String(el.dataset.count || '').replace(/\./g, '').replace(',', '.');
          var to = parseFloat(raw);
          var suffix = el.dataset.suffix || '';
          if (isNaN(to)) return;
          var dur = 1100, start = null;
          var fmt = function (v) { return Math.round(v).toLocaleString('da-DK') + suffix; };
          var step = function (ts) {
            if (!start) start = ts;
            var k = Math.min(1, (ts - start) / dur);
            var e = 1 - Math.pow(1 - k, 3);
            el.textContent = fmt(to * e);
            if (k < 1) requestAnimationFrame(step); else el.textContent = fmt(to);
          };
          requestAnimationFrame(step);
        };

        if (!animate) {
          this.querySelectorAll('.adv-om__stat-n[data-count]').forEach(function (n) {
            var raw = String(n.dataset.count || '').replace(/\./g, '').replace(',', '.');
            var to = parseFloat(raw);
            if (!isNaN(to)) n.textContent = Math.round(to).toLocaleString('da-DK') + (n.dataset.suffix || '');
          });
          return;
        }

        this.classList.add('is-armed');
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (!en.isIntersecting) return;
            en.target.classList.add('is-in');
            en.target.querySelectorAll('.adv-om__stat-n[data-count]').forEach(countUp);
            io.unobserve(en.target);
          });
        }, { threshold: 0.2 });
        this.querySelectorAll('[data-reveal]').forEach(function (el) { io.observe(el); });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["adv-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('adv-review-carousel')) {
    customElements.define('adv-review-carousel', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.prev = this.querySelector('[data-prev]');
        this.next = this.querySelector('[data-next]');
        if (!this.track) return;

        const step = () => {
          const card = this.track.querySelector('.adv-rev__card');
          return card ? card.offsetWidth + 22 : 320;
        };
        this.prev.addEventListener('click', () => this.track.scrollBy({ left: -step(), behavior: 'smooth' }));
        this.next.addEventListener('click', () => this.track.scrollBy({ left: step(), behavior: 'smooth' }));

        const paintArrows = () => {
          const max = this.track.scrollWidth - this.track.clientWidth - 2;
          this.prev.disabled = this.track.scrollLeft <= 2;
          this.next.disabled = this.track.scrollLeft >= max;
        };
        this.track.addEventListener('scroll', paintArrows, { passive: true });
        window.addEventListener('resize', paintArrows);
        paintArrows();

        let down = false, startX = 0, startL = 0, moved = false;
        this.track.addEventListener('pointerdown', (e) => {
          if (e.pointerType !== 'mouse') return;
          down = true; moved = false; startX = e.clientX; startL = this.track.scrollLeft;
          this.track.classList.add('is-drag');
        });
        window.addEventListener('pointermove', (e) => {
          if (!down) return;
          const dx = e.clientX - startX;
          if (Math.abs(dx) > 4) moved = true;
          this.track.scrollLeft = startL - dx;
        });
        window.addEventListener('pointerup', () => { down = false; this.track.classList.remove('is-drag'); });
        this.track.addEventListener('click', (e) => { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);

        var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (this.dataset.animate === 'true' && !reduce && ('IntersectionObserver' in window)) {
          this.classList.add('is-armed');
          var host = this;
          var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (en) { if (en.isIntersecting) { host.classList.add('is-in'); io.disconnect(); } });
          }, { threshold: 0.25 });
          io.observe(this);
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["adv-stat"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('adv-stat-num')) {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var count = function (el, animate, opts) {
      opts = opts || {};
      var raw = String(el.dataset.to !== undefined ? el.dataset.to : el.dataset.count);
      var to = parseFloat(raw.replace(',', '.'));
      var suffix = el.dataset.suffix || '';
      var dec = (raw.indexOf(',') > -1 || raw.indexOf('.') > -1) ? 1 : 0;
      if (isNaN(to)) { return; }
      var apply = function () { el.textContent = to.toFixed(dec).replace('.', ',') + suffix; };
      if (!animate) { apply(); return; }
      var run = function () {
        var dur = 1100, start = null;
        var step = function (ts) {
          if (!start) start = ts;
          var k = Math.min(1, (ts - start) / dur);
          var e = 1 - Math.pow(1 - k, 3);
          el.textContent = (to * e).toFixed(dec).replace('.', ',') + suffix;
          if (k < 1) { requestAnimationFrame(step); }
          else { apply(); if (opts.pop) { el.classList.add('is-pop'); } }
        };
        requestAnimationFrame(step);
      };
      if (opts.delay) { setTimeout(run, opts.delay); } else { run(); }
    };
    var play = function (root, animate) {
      if (animate) { root.classList.add('is-in'); }
      root.querySelectorAll('.adv-stat__num[data-num]').forEach(function (n) { count(n, animate, { delay: 200, pop: true }); });
      root.querySelectorAll('.adv-stat__bar-v[data-count]').forEach(function (n, i) { count(n, animate, { delay: 400 + i * 180 }); });
      root.querySelectorAll('.adv-stat__fill').forEach(function (f, i) {
        if (!animate) { f.style.transition = 'none'; f.style.width = (f.dataset.w || 0) + '%'; return; }
        f.style.transitionDelay = (0.3 + i * 0.18) + 's';
        requestAnimationFrame(function () { f.style.width = (f.dataset.w || 0) + '%'; });
      });
    };
    var init = function () {
      document.querySelectorAll('[data-stat-root]').forEach(function (root) {
        var animate = root.dataset.animate === 'true' && !reduce && ('IntersectionObserver' in window);
        if (!animate) { play(root, false); return; }
        root.classList.add('is-armed');
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { if (en.isIntersecting) { play(root, true); io.disconnect(); } });
        }, { threshold: 0.35 });
        io.observe(root);
      });
    };
    if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
    customElements.define('adv-stat-num', class extends HTMLElement {});
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["adv-vip-signup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('adv-vip-signup')) {
    customElements.define('adv-vip-signup', class extends HTMLElement {
      connectedCallback() {
        this.start = Date.parse(this.dataset.start);
        this.end = Date.parse(this.dataset.end);
        this.form = this.querySelector('[data-form]');
        this.input = this.form.querySelector('[data-email]');
        this.nameInput = this.form.querySelector('[data-name]');
        this.err = this.querySelector('[data-err]');
        this.btn = this.querySelector('[data-btn]');
        this.cd = this.querySelector('[data-countdown]');
        [this.input, this.nameInput].forEach((el) => el.addEventListener('input', () => { this.err.textContent = ''; el.classList.remove('is-invalid'); }));
        this.form.addEventListener('submit', (e) => { e.preventDefault(); this.submit(); });
        this.tick();
        this.timer = setInterval(() => this.tick(), 1000);
      }

      disconnectedCallback() { clearInterval(this.timer); }

      phase() {
        const now = Date.now();
        if (!isNaN(this.end) && now >= this.end) return 'ended';
        if (!isNaN(this.start) && now >= this.start) return 'live';
        return 'before';
      }

      tick() {
        const p = this.phase();
        if (p !== this.current) {
          this.current = p;
          this.querySelectorAll('[data-state]').forEach((el) => { el.hidden = el.dataset.state !== p; });
          const closed = p === 'ended';
          if (!this.done) this.form.hidden = closed;
          this.querySelector('[data-perks]').hidden = closed;
          this.cd.hidden = closed;
        }
        const target = p === 'before' ? this.start : this.end;
        if (isNaN(target)) { this.cd.hidden = true; return; }
        const d = Math.max(0, target - Date.now());
        const set = (k, v) => { const el = this.cd.querySelector('[data-cd="' + k + '"]'); if (el) el.textContent = v; };
        set('d', Math.floor(d / 864e5));
        set('h', Math.floor((d % 864e5) / 36e5));
        set('m', Math.floor((d % 36e5) / 6e4));
        set('s', Math.floor((d % 6e4) / 1e3));
      }

      trackLead() {
        if (this.leadSent) return;
        this.leadSent = true;
        const eventId = 'vip-' + Date.now() + '-' + Math.random().toString(36).slice(2, 8);
        const data = { content_name: 'VIP Weekend 2026', content_category: 'VIP signup', currency: 'DKK', value: 0 };
        // 1) Meta pixel loaded directly on the page (base code / pixel helper setup)
        try { if (typeof window.fbq === 'function') window.fbq('track', 'Lead', data, { eventID: eventId }); } catch (e) {}
        // 2) Shopify Customer Events: picked up by the "VIP Lead" custom pixel (consent-aware)
        try {
          if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
            window.Shopify.analytics.publish('vip_lead', { event_id: eventId, content_name: data.content_name });
          }
        } catch (e) {}
        // 3) GTM / dataLayer, if used
        try { (window.dataLayer = window.dataLayer || []).push({ event: 'vip_lead', event_id: eventId }); } catch (e) {}
      }

      async submit() {
        const name = this.nameInput.value.trim();
        const email = this.input.value.trim();
        if (!name) {
          this.err.textContent = 'Skriv dit fornavn først';
          this.nameInput.classList.add('is-invalid');
          this.nameInput.focus();
          return;
        }
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
          this.err.textContent = 'Skriv en gyldig e-mail først';
          this.input.classList.add('is-invalid');
          this.input.focus();
          return;
        }
        if (!this.dataset.key || !this.dataset.list) {
          this.err.textContent = 'Tilmeldingen er ikke sat op endnu. Prøv igen senere.';
          return;
        }
        this.btn.disabled = true;
        try {
          const body = {
            data: {
              type: 'subscription',
              attributes: {
                custom_source: this.dataset.source || 'VIP landing page',
                profile: { data: { type: 'profile', attributes: { email: email, first_name: name, properties: { vip_weekend_2026: true } } } }
              },
              relationships: { list: { data: { type: 'list', id: this.dataset.list } } }
            }
          };
          const res = await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(this.dataset.key), {
            method: 'POST',
            headers: { 'Content-Type': 'application/vnd.api+json', revision: '2024-10-15' },
            body: JSON.stringify(body)
          });
          if (!res.ok && res.status !== 202) throw new Error('subscribe failed');
          this.done = true;
          this.form.hidden = true;
          const live = this.phase() === 'live';
          const ok = this.querySelector('[data-ok]');
          ok.hidden = false;
          ok.querySelector('[data-ok-before]').hidden = live;
          ok.querySelector('[data-ok-live]').hidden = !live;
          const lb = ok.querySelector('[data-ok-live-btn]');
          if (lb) lb.hidden = !live;
          this.trackLead();
          try { window.dispatchEvent(new CustomEvent('adv:vip-signup', { detail: { list: this.dataset.list } })); } catch (e) {}
        } catch (e) {
          this.err.textContent = 'Noget gik galt. Prøv igen om et øjeblik.';
        } finally {
          this.btn.disabled = false;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["advertorial-sleepiva"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var init = function () {
      document.querySelectorAll('[data-adv-root]').forEach(function (root) {
        if (root.dataset.advInit) return;
        root.dataset.advInit = '1';

        var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        // Soft reveals
        if (!reduce && 'IntersectionObserver' in window) {
          root.classList.add('is-armed');
          var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (en) {
              if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
            });
          }, { threshold: 0.15 });
          root.querySelectorAll('[data-reveal]').forEach(function (el) { io.observe(el); });
        }

        // Sticky mobile CTA: show after scrolling past the header, hide at the CTA card
        var sticky = root.querySelector('[data-sticky]');
        if (sticky) {
          var anchor = root.querySelector('[data-cta-anchor]');
          var onScroll = function () {
            var past = window.scrollY > 500;
            var atCta = false;
            if (anchor) {
              var r = anchor.getBoundingClientRect();
              atCta = r.top < window.innerHeight && r.bottom > 0;
            }
            var show = past && !atCta;
            sticky.classList.toggle('is-visible', show);
            sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
          };
          window.addEventListener('scroll', onScroll, { passive: true });
          onScroll();
        }
      });
    };
    if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sadas"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('challenge-section')) {
    customElements.define('challenge-section', class extends HTMLElement {
      connectedCallback() {
        this.stage = this.querySelector('[data-stage]');
        this.chips = Array.from(this.querySelectorAll('[data-chip]'));
        this.panels = Array.from(this.querySelectorAll('[data-panel]'));
        this.active = 0;

        this.chips.forEach((chip) => {
          chip.addEventListener('click', () => {
            const i = parseInt(chip.dataset.chip, 10);
            if (i === this.active) return;
            this.active = i;
            this.chips.forEach((c) => { c.classList.remove('is-active'); c.setAttribute('aria-selected', 'false'); });
            chip.classList.add('is-active');
            chip.setAttribute('aria-selected', 'true');
            this.show(i);
          });
        });

        var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (this.dataset.animate === 'true' && !reduce && ('IntersectionObserver' in window)) {
          this.classList.add('is-armed');
          var host = this;
          var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (en) { if (en.isIntersecting) { host.classList.add('is-in'); io.disconnect(); } });
          }, { threshold: 0.25 });
          io.observe(this);
        }
      }

      show(i) {
        this.stage.classList.add('is-out');
        setTimeout(() => {
          this.panels.forEach((p) => { p.hidden = parseInt(p.dataset.panel, 10) !== i; });
          this.stage.classList.remove('is-out');
        }, 180);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sadasda"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('adv-faq')) {
    customElements.define('adv-faq', class extends HTMLElement {
      connectedCallback() {
        this.single = this.dataset.single === 'true';
        this.items = Array.from(this.querySelectorAll('[data-item]'));
        this.items.forEach((item, idx) => {
          const btn = item.querySelector('[data-q]');
          btn.addEventListener('click', () => this.toggle(item, btn));
          if (idx === 0 && this.dataset.firstOpen === 'true') this.open(item, btn);
        });
      }
      open(item, btn) { item.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); }
      close(item, btn) { item.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false'); }
      toggle(item, btn) {
        const isOpen = item.classList.contains('is-open');
        if (this.single) this.items.forEach((it) => { if (it !== item) this.close(it, it.querySelector('[data-q]')); });
        if (isOpen) this.close(item, btn); else this.open(item, btn);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
